import React, { useState, useContext } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import Alert from '../alert/alert';
import { cognitoCompleteNewPassword, changeAuthState, AuthState } from '../../helpr/authHelper';
import { AUTH_INVALID_PASSWORD } from '../../helpr/constants';
import { IdentityContext } from '../../context/identity-context';
import styles from '../custom-forgot-password/custom-forgot-password.module.scss';
import passwordIcon from '../../assets/login-password-icon.svg';

const CustomRequireNewPassword = () => {
  const { pendingUsername } = useContext(IdentityContext);
  const username = pendingUsername;
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showErr, setShowErr] = useState({
    msg: '',
    type: 'alert-danger-custom',
    isVisible: false,
    onClose: () => setShowErr(s => ({ ...s, isVisible: false })),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword) return setShowErr(s => ({ ...s, isVisible: true, msg: AUTH_INVALID_PASSWORD }));
    if (newPassword !== confirmPassword) return setShowErr(s => ({ ...s, isVisible: true, msg: 'Passwords do not match.' }));

    setLoading(true);
    try {
      await cognitoCompleteNewPassword(newPassword, username);
    } catch (err) {
      setShowErr(s => ({ ...s, isVisible: true, msg: err.message || 'Failed to change password.' }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles['custom-container']}>
      <div className={styles['form-card']}>
        <Alert options={showErr} />
        <div className={styles['header']}>
          <h3>Change Password</h3>
          <span>You must set a new password before continuing.</span>
        </div>
        <div className={styles['form-section']}>
          <Form onSubmit={handleSubmit}>
            <Form.Group className={styles['input-section']} controlId="newPassword">
              <i className={styles['icon']}><img src={passwordIcon} alt="" /></i>
              <Form.Control
                className={styles['forgot-pw-input']}
                type="password"
                placeholder="New Password"
                onChange={e => setNewPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className={styles['input-section']} controlId="confirmPassword">
              <i className={styles['icon']}><img src={passwordIcon} alt="" /></i>
              <Form.Control
                className={styles['forgot-pw-input']}
                type="password"
                placeholder="Confirm New Password"
                onChange={e => setConfirmPassword(e.target.value)}
              />
            </Form.Group>
            <div className={styles['login-button']}>
              <Button disabled={loading} variant="primary" type="submit">
                {loading ? <Spinner size="sm" animation="border" /> : 'CHANGE PASSWORD'}
              </Button>
            </div>
          </Form>
        </div>
        <div className={styles['login-options']}>
          <a href="#" onClick={() => changeAuthState(AuthState.SignIn)}>Back to Sign In</a>
        </div>
      </div>
    </div>
  );
};

export default CustomRequireNewPassword;
